const Index = (resolve) => require(['@/views/base-container.vue'], resolve);
const Home = (resolve) => require(['@/views/home/index.vue'], resolve);
const CustomerCase = (resolve) => require(['@/views/customerCase/index.vue'], resolve);
const CustomerDetails = (resolve) => require(['@/views/customerCase/components/customerDetails.vue'], resolve);
const CasesList = (resolve) => require(['@/views/customerCase/components/casesList.vue'], resolve);
const AdvisoryCenter = (resolve) => require(['@/views/advisoryCenter/index.vue'], resolve);
const AdvisoryList = (resolve) => require(['@/views/advisoryCenter/components/advisoryList.vue'], resolve);
const AdvisoryDetails = (resolve) => require(['@/views/advisoryCenter/components/advisoryDetails.vue'], resolve);
const Solution = (resolve) => require(['@/views/solution/index.vue'], resolve);
const ProductCenter = (resolve) => require(['@/views/productCenter/index.vue'], resolve)
const AboutUs = (resolve) => require(['@/views/aboutUs/index.vue'], resolve);
const Description = (resolve) => require(['@/views/aboutUs/components/description.vue'], resolve);
// 后台
const BackStage = (resolve) => require(['@/views/back-stage-container.vue'], resolve)
const InvitationBackstage = (resolve) => require(['@/views/invitation-backstage/index.vue'], resolve)
    // 新闻详情页
const ComAdvisoryDetails = (resolve) => require(['@/components/com-advisory-details.vue'], resolve);


const routers = [{
        path: '/',
        redirect: '/home'
    }
    // {
    //     path: '/login',
    //     component: Login,
    //     meta: {
    //         auth: false,
    //         header: "none",//none:不显示头部 normal:正常显示头部 
    //         footer: "none",//none:不显示底部 normal:正常显示底部 white:显示白色底部
    //         scroll: "normal",// normal:正常显示内容，即无限下拉 scroll:显示头底之后内容部分滑动 none:显示头底之后，内容部分不滑动
    //     },
    // },
];
let routerMain = {
    path: '/',
    component: Index,
    children: [{
            path: "",
            component: Home,
            meta: {
                auth: false,
                header: "normal",
                footer: "normal",
                scroll: "normal",
            },
        },
        {
            path: "home",
            component: Home,
            meta: {
                auth: false,
                header: "normal",
                footer: "normal",
                scroll: "normal",
            },
        },
        {
            path: "customerCase/",
            component: CustomerCase,
            meta: {
                auth: false,
                header: "normal",
                footer: "normal",
                scroll: "normal",
            },
            children: [{
                path: 'customerDetails',
                component: CustomerDetails,
                meta: {
                    auth: false,
                    header: "normal",
                    footer: "normal",
                    scroll: "normal",
                },
            }, {
                path: '',
                component: CasesList,
                name: 'CustomerCase',
                meta: {
                    auth: false,
                    header: "normal",
                    footer: "normal",
                    scroll: "normal",
                },
            }]
        }, {
            path: '/advisoryDetails',
            component: ComAdvisoryDetails,
            name: 'ComAdvisoryDetails',
            meta: {
                auth: false,
                header: "",
                footer: "",
                scroll: "normal",
            },
        },
        // {
        //     path: 'advisoryCenter/',
        //     component: AdvisoryCenter,
        //     name: 'AdvisoryCenter',
        //     meta: {
        //         auth: false,
        //         header: "normal",
        //         footer: "normal",
        //         scroll: "normal",
        //     },
        //     children: [{
        //         path: '',
        //         component: AdvisoryList,
        //         meta: {
        //             auth: false,
        //             header: "normal",
        //             footer: "normal",
        //             scroll: "normal",
        //         }
        //     }, {
        //         path: 'advisoryDetails',
        //         component: AdvisoryDetails,
        //         meta: {
        //             auth: false,
        //             header: "normal",
        //             footer: "normal",
        //             scroll: "normal",
        //         }
        //     }, ]
        // },
        {
            path: 'productCenter/',
            component: ProductCenter,
            name: 'ProductCenter',
            meta: {
                auth: false,
                header: "normal",
                footer: "normal",
                scroll: "normal",
            },

        },
        {
            path: 'solution',
            component: Solution,
            name: 'Solution',
            meta: {
                auth: false,
                header: "normal",
                footer: "normal",
                scroll: "normal",
            },
            // children: [{
            //     path: '',
            //     component: SolutionDetails,
            //     meta: {
            //         auth: false,
            //         header: "normal",
            //         footer: "normal",
            //         scroll: "normal",
            //     },
            // }]
        },
        // {
        //     path: '/contactUs',
        //     meta: {
        //         auth: false,
        //         header: "normal",
        //         footer: "normal",
        //         scroll: "normal",
        //     }
        // },
        {
            path: 'aboutUs',
            component: AboutUs,
            meta: {
                auth: false,
                header: "normal",
                footer: "normal",
                scroll: "normal",
            },
            children: [{
                path: '',
                component: Description,
                name: 'AboutUs',
                meta: {
                    auth: false,
                    header: "normal",
                    footer: "normal",
                    scroll: "normal",
                },
            }]
        },
        //   {
        //     path: "/cloud-location",
        //     component: CloudLocation,
        //     meta: {
        //         auth: false,
        //         header: "normal",
        //         footer: "none",
        //         scroll: "none",
        //     },
        // },
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
};
let backStageRouter = {
    path: '/website',
    component: BackStage,
    children: [{
        path: '',
        component: InvitationBackstage
    }]
}
routers.push(routerMain, backStageRouter);
export default routers;


// WEBPACK FOOTER //
// ./src/router/index.js